import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import Enter from "./pages/Protected/Enter";
import CourseCreate from "./pages/Protected/CourseCreate";
import ListCourses from "./pages/Protected/ListCourses";
import EditCourse from "./pages/Protected/EditCourse";
import TermsOfService from "./pages/Terms/TermsOfService";
import { PrivacyPolicy } from "./pages/PrivacyPolicy/PrivacyPolicy";
import { ContactUs } from "./pages/ContactUs/ContactUs";
import MatesList from "./pages/Protected/Mates/MatesList";
import MateDetails from "./pages/Protected/Mates/MateDetails";
import EditMate from "./pages/Protected/Mates/EditMate";
import { DeleteData } from "./pages/DeleteData/DeleteData";
import CollectionsList from "./pages/Protected/Collections/CollectionsList";
import CollectionDetails from "./pages/Protected/Collections/CollectionDetails";
import CreateCollection from './pages/Protected/Collections/CreateCollection';
import ChatList from './pages/Protected/Chats/ChatList';
import ChatDetails from './pages/Protected/Chats/ChatDetails';
import DailyPhrase from './pages/Protected/DailyPhrases/DailyPhrase';
import DailyPhraseList from './pages/Protected/DailyPhrases/DailyPhraseList';
import LessonsPreview from './pages/Protected/Lessons/LessonsPreview';
import SouceList from './pages/Protected/Sources/SouceList';
import CreateSource from './pages/Protected/Sources/CreateSource';
import UpdateSource from './pages/Protected/Sources/UpdateSource';
import Dashboard from './pages/Protected/Dashboard';
import RegistrationStatistic from './pages/Protected/RegistrationStatistic';
import Feedbacks from './pages/Protected/Feedbacks';
import AdminLayout from './pages/Protected/AdminLayout';

function App() {
  return <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/enter" element={<Enter />} />
      <Route path="/delete-data" element={<DeleteData />} />
      <Route path="/admin" element={<Navigate to="/dashboard" replace />} />

      {/* Protected Admin Panel Routes wrapped with Collapsible Sidebar Layout */}
      <Route element={<AdminLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/registration-statistic" element={<RegistrationStatistic />} />
        <Route path="/feedbacks" element={<Feedbacks />} />
        <Route path="/course" element={<CourseCreate />} />
        <Route path="/course-list" element={<ListCourses />} />
        <Route path="/course-edit/:courseId" element={<EditCourse />} />
        <Route path="/mates-list" element={<MatesList />} />
        <Route path="/mate-details/:mateId" element={<MateDetails />} />
        <Route path="/mate-edit/:mateId" element={<EditMate />} />
        <Route path="/collections-list" element={<CollectionsList />} />
        <Route path="/collection-details/:id" element={<CollectionDetails />} />
        <Route path="/create-collection" element={<CreateCollection />} />
        <Route path="/chat-list" element={<ChatList />} />
        <Route path="/chat-details/:id" element={<ChatDetails />} />
        <Route path="/daily-phrases/:id" element={<DailyPhrase />} />
        <Route path="/daily-phrases-list" element={<DailyPhraseList />} />
        <Route path="/lessons-preview" element={<LessonsPreview />} />
        <Route path="/sources" element={<SouceList />} />
        <Route path="/source-list" element={<SouceList />} />
        <Route path="/source-create" element={<CreateSource />} />
        <Route path="/create-source" element={<CreateSource />} />
        <Route path="/source-edit/:id" element={<UpdateSource />} />
      </Route>
    </Routes>
  </BrowserRouter>
}

export default App;
